module.exports = __webpack_public_path__ + "ca357ce52fe8546951088cc0ce49a55d.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/home/components/images/video-two.png
 ** module id = 1577
 ** module chunks = 0
 **/